import { BaseModel, BaseModelProps, ReactRenderer } from '@mail/3promo';
import { LocalStorageStore } from '@mail/3promo/stores/localStorage';
import type { ModelCreator } from '@mail/3promo/types';
import modalImage from 'img/closeButtonExperimentModal/closeButtonExperimentModal.png';
import React from 'react';
import { IS_MOBILE_BROWSER, IS_PAID_USER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { isHomeLikeStorage } from 'reactApp/modules/promoNew/items/helpers/homeLikeStorage.helpers';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { isCloudOrMailOrApiOverQuota } from 'reactApp/modules/userQuota/overquota.helpers';
import { store as reduxStore } from 'reactApp/store';

export const CLOSE_BUTTON_EXPERIMENT_MODAL_ID = 'close-button-experiment-modal';

class PopupModel extends BaseModel<BaseModelProps> {
    getParent(): HTMLElement | null {
        return document.documentElement;
    }
}

const LazyComponent = React.lazy(() => import('reactApp/ui/closeButtonExperimentModal/closeButtonExperimentModal'));

const SuspendedComponent = () => {
    return (
        <React.Suspense fallback={null}>
            <LazyComponent />
        </React.Suspense>
    );
};

export const closeButtonExperimentModal: ModelCreator = ({ models, render, stores }) => {
    return new PopupModel(
        CLOSE_BUTTON_EXPERIMENT_MODAL_ID,
        models.base,
        new BaseModelProps(CLOSE_BUTTON_EXPERIMENT_MODAL_ID, {
            store: new LocalStorageStore(CLOSE_BUTTON_EXPERIMENT_MODAL_ID, stores.localStorage),
            renderer: new ReactRenderer(CLOSE_BUTTON_EXPERIMENT_MODAL_ID, SuspendedComponent, render.react),
            showLimit: 3,
            showInterval: 259200,
            templateData: {},
            ignoreTestOnRedraw: true,
            preloadingImages: [modalImage],
            test: (resolve, reject) => {
                const state = reduxStore.getState();
                const storage = getCurrentStorage(state);

                if (!isHomeLikeStorage(storage)) {
                    reject();
                    return;
                }

                const isBizUser = UserSelectors.isBizUser(state);
                const isCorpUser = UserSelectors.isCorpUser(state);
                const isOverquota = isCloudOrMailOrApiOverQuota(state);

                const isReject = IS_WEBVIEW || IS_MOBILE_BROWSER || IS_PAID_USER || isBizUser || isCorpUser || isOverquota;

                if (isReject) {
                    reject();
                    return;
                }

                resolve();
            },
        })
    );
};
